import { AsyncPipe } from '@angular/common';
import { Component, OnInit, inject, input } from '@angular/core';

import { Observable, combineLatest } from 'rxjs';

import { FormComponent } from '@camelot/form-basic';
import { CamAbstractInput } from '@camelot/form-model';
import { ENotificationCode, LAZY_SERVICE_TOKEN } from '@camelot/notification';
import { ErrorComponent, LoaderComponent, TextComponent } from '@camelot/ui';
import { CamBaseComponent } from '@camelot/utils';

import { TextToClipboardComponent } from '../../../../../../components/text-to-clipboard/text-to-clipboard.component';
import { TemplateVariant } from '../../../../services/dto/template';
import { CamCommunicationsTemplateFormService } from '../../../../services/form/template.service';
import { CamCommunicationsTemplatesService } from '../../../../services/templates.service';

@Component({
  selector: 'cam-communication-template-variant-edit',
  templateUrl: './variant-edit.component.html',
  styleUrls: ['./variant-edit.component.scss'],
  imports: [LoaderComponent, ErrorComponent, TextComponent, FormComponent, TextToClipboardComponent, AsyncPipe],
})
export class VariantEditComponent extends CamBaseComponent implements OnInit {
  id = input.required<string>();

  variants = input<TemplateVariant[]>([]);

  protected _notificationService = inject(LAZY_SERVICE_TOKEN);

  readonly communicationsTemplateFormService = inject(CamCommunicationsTemplateFormService);
  readonly communicationsTemplateService = inject(CamCommunicationsTemplatesService);

  public templateKeys$: Observable<string[] | null>;
  public form: CamAbstractInput[] | null = null;

  constructor() {
    super();
    this.templateKeys$ = this.communicationsTemplateService.templateKeys.get$();
    this.communicationsTemplateService.fetchConversationTemplateKeys$().subscribe();
  }
  ngOnInit() {
    this.setForm(this.variants());
  }
  public setForm(variants?: TemplateVariant[]) {
    this.form = this.communicationsTemplateFormService.getTemplateVariantForm(variants ?? []);
  }

  public createVariants(data: any) {
    this.requestState.asked();

    const variants = this.communicationsTemplateFormService.formatTemplatevariantForm(data);

    const request$ = variants.map(variant => {
      const findVariant = this.variants().find(v => v.culture === variant.culture);

      if (findVariant) {
        return this.communicationsTemplateService.updateVariants$({
          ...variant,
          ...{ id: findVariant.id },
        });
      }

      return this.communicationsTemplateService.createVariants$({
        ...variant,
        ...{ templateId: this.id() },
      });
    });

    combineLatest(request$).subscribe({
      complete: () => {
        this.requestState.completed();
        this._notificationService.addNotification('notification.common.success', ENotificationCode.success);
      },
      error: () => {
        this.requestState.completed();
      },
    });
  }
}
